// extracted by mini-css-extract-plugin
export var active = "_g4-7";
export var blink = "_g4-8";
export var dropDownSelector = "_g4-4";
export var dropDownWrapper = "_g4-3";
export var fakeCursor = "_g4-6";
export var fontSizeButton = "_g4-9";
export var formQuillEditor = "_g4-0";
export var pressed = "_g4-a";
export var qlBlank = "_g4-1";
export var textFormattingToolbar = "_g4-2";
export var textToolbarOption = "_g4-5";